import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const TriggerReturnCreationSideEffectsResultSchema_ = z.object({
  returnId: z.string(),
  success: z.boolean(),
  message: z.string(),
});
export interface TriggerReturnCreationSideEffectsResult extends z.infer<
  typeof TriggerReturnCreationSideEffectsResultSchema_
> {}
export const TriggerReturnCreationSideEffectsResultSchema: z.ZodType<TriggerReturnCreationSideEffectsResult> =
  TriggerReturnCreationSideEffectsResultSchema_;

export const triggerReturnCreationSideEffects = unaryRpc({
  name: "triggerReturnCreationSideEffects",
  input: z.object({ returnIds: z.array(z.string()) }),
  output: z.object({
    results: z.array(TriggerReturnCreationSideEffectsResultSchema),
  }),
});
